type AnalyticsPayload = Record<string, unknown>;

export function trackAnalytics(event: string, payload: AnalyticsPayload = {}) {
  console.info("[analytics]", event, payload);
}
